import { ResourceFavoriteMutationActionType } from './types';
import { EntityAction } from '../../types';

const defaultState = {
  favoriteResources: []
};
const resourceFavoritesReducer = (state = defaultState as any, action: EntityAction) => {
  switch (action.type) {
    case ResourceFavoriteMutationActionType.CREATE_FAVORITE_SUCCESS: {
      const { userFavorite } = action.data;
      const favoriteResources = state.favoriteResources.filter(({ id }) => id !== userFavorite.id);

      favoriteResources.push(userFavorite);
      return {
        ...state,
        favoriteResources
      };
    }
    case ResourceFavoriteMutationActionType.REMOVE_FAVORITE_SUCCESS: {
      const { favoriteId } = action.data;
      const favoriteResources = state.favoriteResources.filter(({ id }) => id !== favoriteId);

      return {
        ...state,
        favoriteResources
      };
    }
    // TODO move
    case 'RESET_RESOURCES': {
      return {
        ...state,
        resources: []
      };
    }
    default:
      return state;
  }
};

export default resourceFavoritesReducer;
